import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import store from '../src/store/index';
import { Provider } from 'react-redux'
import { I18nextProvider } from "react-i18next";
import i18next from "i18next";
import en from "./translations/en.json";
import { ToastContainer, Bounce } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import './assets/css/mega-menu.css';

import { AuthProvider } from "react-oidc-context"
const oidcConfig = {
	authority: "https://appcentral.dev.apteancloud.dev/iam/auth/realms/aptean-staging",
	client_id:  "PO28S1UM0XI9IJHOG",
	redirect_uri: process.env.REACT_APP_IAM,
	post_logout_redirect_uri: process.env.REACT_APP_IAM
  
};

const handleSigninCallback = () => {
	//remove the code and state parameters from the url when you are redirected from the authorize page.
	window.history.replaceState({}, document.title, window.location.pathname);
};


i18next.init({
	interpolation: { escapeValue: false },  // React already does escaping
	lng: 'en',                              // language to use
	resources: {
		en: {
			common: en               // 'common' is our custom namespace
		}
	},
});

ReactDOM.render(
	// <React.StrictMode>
	//   <App />
	// </React.StrictMode>,
	<Provider store={store}>
		<I18nextProvider i18n={i18next}>
			<ToastContainer autoClose={2000} hideProgressBar={true} transition={Bounce}/>
				<AuthProvider 
					{...oidcConfig}
        			onSigninCallback = {handleSigninCallback} 
				>
					<App />
				</AuthProvider>
		</I18nextProvider>
	</Provider>,
	document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
